import { useRef } from "react";
import AnalyticsSession from "../utils/AnalyticsSession";

export interface UseAnalyticsProps {
  salesPersonId: string;
  storeId: string;
  storeCountry: string;
  storeName: string;
  countryName: string;
}

export default function useAnalytics({
  salesPersonId,
  storeId,
  storeCountry,
  storeName,
  countryName
}: UseAnalyticsProps) {
  return useRef<AnalyticsSession>(
    new AnalyticsSession(
      salesPersonId,
      storeId,
      storeCountry,
      storeName,
      countryName
    )
  );
}
